import { lazy } from "react";

export const Registration = lazy(() => import("./Pages/Registration.tsx"));
export const ForgotPassword = lazy(() => import("./Pages/ForgotPassword.tsx"));
export const ResetPassword = lazy(() => import("./Pages/ResetPassword.tsx"));
export const CandidateDashboard = lazy(
  () => import("./Pages/Candidate/CandidateDashboard.tsx"),
);
export const ParticipationInApplicationProcess = lazy(
  () => import("./Pages/Candidate/ParticipationInApplicationProcess.tsx"),
);
export const OpenApplicationProcesses = lazy(
  () => import("./Pages/Candidate/OpenApplicationProcesses.tsx"),
);
export const CommitteeDashboard = lazy(
  () => import("./Pages/Committee/CommitteeDashboard.tsx"),
);
export const ParticipationsInFieldOfStudyList = lazy(
  () => import("./Pages/Committee/ParticipationsInFieldOfStudyList.tsx"),
);
export const Participation = lazy(
  () => import("./Pages/Committee/Participation.tsx"),
);
export const ApplicationProcessList = lazy(
  () => import("./Pages/Admin/ApplicationProcessList.tsx"),
);
export const ApplicationProcessForm = lazy(
  () => import("./Pages/Admin/ApplicationProcessForm.tsx"),
);
export const CommitteeMemberList = lazy(
  () => import("./Pages/Admin/CommitteeMemberList.tsx"),
);
export const AcceptInvitation = lazy(
  () => import("./Pages/AcceptInvitation.tsx"),
);
